module.exports = __webpack_public_path__ + "media/images/bul-howto-0307876f.gif";